// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__ZlVSD","errorLogs":"styles_errorLogs__231FZ"};